import { render, staticRenderFns } from "./register.vue?vue&type=template&id=5d190a7a"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Field: require('/home/ubuntu/containers/hermes_eshop/components/core/field.vue').default,Check: require('/home/ubuntu/containers/hermes_eshop/components/core/check.vue').default})
